// import React from 'react';
// import jawlogo from '../../Images/jaw-logo.png';
// import telturboLogo from '../../Images/telturbo-logo.jpg';
// import telturbo1 from '../../Images/telturbo1.jpg';
// import rane2 from '../../Images/rane2.jpg';
// import rane3 from '../../Images/rane3.jpg';
// import rane4 from '../../Images/rane4.jpg';
// import rane6 from '../../Images/rane6.jpg';
// import rane7 from '../../Images/rane7.jpg';
// import rane8 from '../../Images/rane8.jpg';
// import rane9 from '../../Images/rane9.jpg';
// import rane10 from '../../Images/rane10.jpg';
// import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

// // Placeholder images for the gallery and QR codes.
// const galleryImages = [
//   rane4,
//   rane6,
//   rane7,
//   rane8,
//   rane9,
//   rane10
//   // Add more gallery images here
// ];

// const qrCodeHospet = 'https://via.placeholder.com/150';
// const qrCodeChitradurga = 'https://via.placeholder.com/150';
// const qrCodeBallari = 'https://via.placeholder.com/150';

// const JAW_TELTURBO = () => {
//   return (
//     <div className='min-h-screen pt-20'>
//       {/* Hero Section */}
//       <div className='w-full h-auto py-12 bg-gradient-to-r from-blue-600 to-blue-800 flex flex-col justify-center items-center px-4 md:px-8'>
//         <div className='flex flex-col md:flex-row justify-center items-center gap-4 text-center'>
//           <img src={jawlogo} alt="jaw-logo" className='h-16 w-16 md:h-24 md:w-24' />
//           <div className='text-white'>
//             <h1 className='text-2xl md:text-5xl font-bold'>JANATHA AUTO WORKS</h1>
//             <span className='text-sm md:text-xl font-semibold bg-green-400 p-1 md:p-2 rounded-md mt-2 inline-block'>TEL TURBO AUTHORISED SERVICE CENTRE</span>
//             <h2 className='text-md md:text-2xl font-normal mt-2'>Trusted. Trained. Turbocharged. Your official TEL TURBO Authorised Service Centre where performance meets precision.</h2>
//           </div>
//         </div>
//       </div>
      
//       {/* Description Section */}
//       <div className='pt-12 mx-auto px-4 sm:px-8 md:px-12 lg:px-20'>
//         <div className='flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left'>
//           <img src={telturboLogo} alt="tel-turbo-logo" className='h-16 md:h-24' />
//           <h2 className='text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 font-sans mt-4 md:mt-0'>Precision Turbo Solutions Since 2007</h2>
//         </div>
//         <p className='px-4 md:px-20 text-center text-sm md:text-lg lg:text-xl pt-4 text-gray-700'>
//           Welcome to Janatha Auto Works, your official TEL TURBO Authorised Service Centre (ASC) — where performance meets precision. Whether you demand power, reliability, or speed, we deliver factory-certified expertise and world-class service to keep your machines operating at peak performance.
//         </p>
//       </div>

//       {/* 3-Cards Section */}
//       <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 py-12'>
//         {/* Card 1 */}
//         <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
//           <h3 className='text-xl md:text-2xl font-semibold text-center py-2'>1 Factory-Trained Technicians</h3>
//           <p className='text-center text-sm md:text-base'>Our technicians are trained by TEL professionals to handle everything from routine check-ups to complex diagnostics — with skill, care, and unmatched precision.</p>
//         </div>

//         {/* Card 2 */}
//         <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
//           <h3 className='text-xl md:text-2xl font-semibold text-center py-2'>2 Inventory – Always Stocked, Always Ready</h3>
//           <p className='text-center text-sm md:text-base'>We ensure rapid turnaround times, high availability of spares, and minimal downtime for your fleet.</p>
//         </div>

//         {/* Card 3 */}
//         <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
//           <h3 className='text-xl md:text-2xl font-semibold text-center py-2'>3 Comprehensive Turbo Solutions</h3>
//           <p className='text-center text-sm md:text-base'>We offer preventive & scheduled maintenance, diagnostics, overhauls, road assistance, and sales of genuine TEL TURBO spares.</p>
//         </div>
//       </div>

//       {/* Why Choose Section */}
//       <div className='grid grid-cols-1 md:grid-cols-2 p-8 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 shadow-2xl rounded-lg bg-gray-50'>
//         <div className='space-y-4'>
//           <h3 className='text-2xl md:text-3xl font-semibold text-gray-800'>Why Choose Janatha Auto Works?</h3>
//           <p className='text-sm md:text-base text-gray-600'>As an officially certified TEL TURBO ASC since 2007, we guarantee:</p>
//           <ul className='space-y-2 text-sm md:text-base text-gray-600'>
//             <li>✓ 100% Genuine Spare Parts</li>
//             <li>✓ Warranty-Compliant Repairs & Servicing</li>
//             <li>✓ Direct Technical Support from TEL TURBO</li>
//             <li>✓ Factory-Trained Technicians</li>
//             <li>✓ Rapid Turnaround Times</li>
//           </ul>
//         </div>
//         <div>
          
//           <div className='space-y-4'>
//             <img src={telturbo1} alt="jaw-main" className='w-full h-auto md:h-72 object-contain border-2 border-green-400 rounded-xl' />
        
//           </div>
//         </div>
//       </div>
      
//       {/* Gallery Section */}
//       <div className='py-12 mx-4 sm:mx-8 md:mx-12 lg:mx-20 pt-12'>
//         <h2 className='text-3xl md:text-4xl font-bold text-center mb-8 text-gray-900'>Gallery</h2>
//         <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
//           {galleryImages.map((image, index) => (
//             <div key={index} className='overflow-hidden rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105'>
//               <img src={image} alt={`Gallery image ${index + 1}`} className='w-full h-40 md:h-52 object-cover' />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Contact/Footer Section as per image */}
//       <div className='py-12 bg-gray-900 text-white text-center px-4 sm:px-8 md:px-12 lg:px-20'>
//         <div className='max-w-4xl mx-auto'>
//           <h2 className='text-2xl md:text-3xl lg:text-4xl font-bold font-sans mb-2 text-cyan-400'>Let's Get You Turbocharged</h2>
//           <p className='text-sm md:text-base text-gray-300 mb-8'>
//             Need expert service, genuine parts, or a maintenance partner you can trust? We're just a call away.
//           </p>
//         </div>

//         <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
//           {/* Card 1: Contact Information */}
//           <div className='bg-gray-800 p-6 rounded-lg shadow-lg'>
//             <h3 className='text-xl font-bold mb-4'>Contact Information</h3>
//             <div className='space-y-4 text-left'>
//               <div>
//                 <p className='text-sm font-semibold mb-1 text-blue-300'>Hospet</p>
//                 <div className='flex items-center space-x-2 text-gray-400'>
//                   <FaPhoneAlt className='text-blue-400' />
//                   <span>88840 13007</span>
//                 </div>
//                 <div className='flex items-center space-x-2 text-gray-400 mt-1'>
//                   <FaEnvelope className='text-blue-400' />
//                   <span>jaw.hpt@gmail.com</span>
//                 </div>
//               </div>
//               <hr className='border-gray-700' />
//               <div>
//                 <p className='text-sm font-semibold mb-1 text-blue-300'>Chitradurga</p>
//                 <div className='flex items-center space-x-2 text-gray-400'>
//                   <FaPhoneAlt className='text-blue-400' />
//                   <span>9742153614</span>
//                 </div>
//                 <div className='flex items-center space-x-2 text-gray-400 mt-1'>
//                   <FaEnvelope className='text-blue-400' />
//                   <span>jaw.durga@gmail.com</span>
//                 </div>
//               </div>
//               <hr className='border-gray-700' />
//               <div>
//                 <p className='text-sm font-semibold mb-1 text-blue-300'>Ballari</p>
//                 <div className='flex items-center space-x-2 text-gray-400'>
//                   <FaPhoneAlt className='text-blue-400' />
//                   <span>9008788087</span>
//                 </div>
//                 <div className='flex items-center space-x-2 text-gray-400 mt-1'>
//                   <FaEnvelope className='text-blue-400' />
//                   <span>jaw.hpt@gmail.com</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Card 2: Hospet Address */}
//           <div className='bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
//             <h3 className='text-xl font-bold mb-4'>Hospet Address</h3>
//             <p className='text-sm text-gray-400 mb-4'>Scan for directions</p>
//             <img src={qrCodeHospet} alt="QR Code Hospet" className='w-40 h-40 rounded-lg bg-white' />
//             <p className='mt-4 text-sm text-gray-400 text-center'>Near RTO Office, Harihar Road</p>
//           </div>

//           {/* Card 3: Chitradurga Address */}
//           <div className='bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
//             <h3 className='text-xl font-bold mb-4'>Chitradurga Address</h3>
//             <p className='text-sm text-gray-400 mb-4'>Scan for directions</p>
//             <img src={qrCodeChitradurga} alt="QR Code Chitradurga" className='w-40 h-40 rounded-lg bg-white' />
//             <p className='mt-4 text-sm text-gray-400 text-center'>Opp Bapuji High School, NH-13 Road</p>
//           </div>
          
//           {/* Card 4: Ballari Address */}
//           <div className='bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
//             <h3 className='text-xl font-bold mb-4'>Ballari Address</h3>
//             <p className='text-sm text-gray-400 mb-4'>Scan for directions</p>
//             <img src={qrCodeBallari} alt="QR Code Ballari" className='w-40 h-40 rounded-lg bg-white' />
//             <p className='mt-4 text-sm text-gray-400 text-center'>Plot no 1057/B, Old Bypass, Cowl Bazar Road, Opp. Eidgah, Behind Golden Function Hall, Ballari - 583102.</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default JAW_TELTURBO;
import React, { useState, useEffect } from 'react';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { BsCheckCircleFill } from 'react-icons/bs';
import jawlogo from '../../Images/jaw-logo.png';
import telturboLogo from '../../Images/telturbo-logo.jpg';
import telturbo1 from '../../Images/telturbo1.jpg';
import telturbo2 from '../../Images/tel-turbo2.jpg';
import telturbo3 from '../../Images/tel-turbo3.jpg';
import telturbo4 from '../../Images/tel-turbo4.jpg';
import telturbo5 from '../../Images/tel-turbo5.jpg';
import telturbo6 from '../../Images/tel-turbo6.jpg';
import telturbo7 from '../../Images/tel-turbo2.jpg';
import telturbo8 from '../../Images/tel-turbo8.jpg';

const branches = [
  { main: "Tel Turbo", subs: ["Hospet", "Chitradurga", "Ballari"] },
  // add other branches here if needed
];

const getBranchKey = (main, sub) => (sub ? `${main}::${sub}` : main);

const API_BASE_URL = (process.env.NODE_ENV === 'production' ? 'https://japl-backend-v2jm.onrender.com/api' : 'http://localhost:5000/api')
// const API_BASE_URL = 'http://localhost:5000/api'


const JAW_TELTURBO = () => {
  const [qrCodes, setQrCodes] = useState({});

  useEffect(() => {
    async function fetchQRs() {
      const codes = {};
      for (const { main, subs } of branches) {
        // Only fetch main alone if no subs or subs is single empty string
        if (subs.length === 0 || (subs.length === 1 && subs[0] === "")) {
          const key = main;
          try {
            const res = await fetch(`${API_BASE_URL}/branchqrcode/${encodeURIComponent(key)}`);
            if (res.ok) {
              const data = await res.json();
              codes[key] = `https://japl-backend-v2jm.onrender.com${data.qrCodeImageURL}`;
            }
          } catch (err) {
            console.log(`Error fetching ${key}`, err);
          }
        } else {
          for (const sub of subs) {
            if (!sub) continue;
            const key = getBranchKey(main, sub);
            try {
              const res = await fetch(`${API_BASE_URL}/branchqrcode/${encodeURIComponent(key)}`);
              if (res.ok) {
                const data = await res.json();
                codes[key] = `https://japl-backend-v2jm.onrender.com${data.qrCodeImageURL}`;
              }
            } catch (err) {
              console.log(`Error fetching ${key}`, err);
            }
          }
        }
      }
      setQrCodes(codes);
    }
    fetchQRs();
  }, []);

  return (
    <div className='bg-gray-50 font-sans text-gray-800'>
      {/* Hero Section */}
      <section className='relative h-96 md:h-[400px] overflow-hidden'>
        <div className='absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-700 opacity-90'></div>
        <img
          src={telturbo3}
          alt="Turbo background"
          className='absolute inset-0 w-full h-full object-cover'
        />
        <div className="absolute inset-0 h-[390px] md:h-[370px] lg:h-[400px] bg-black/30"/>
        <div className='pt-12 absolute inset-0 flex items-center justify-center px-6 text-white text-center'>
          <div className='max-w-4xl'>
            <div className='flex flex-col md:flex-row items-center justify-center gap-6 mb-8'>
              <img src={jawlogo} alt="JAW Logo" className='w-20 h-20 md:w-24 md:h-24 rounded-full' />
              <h1 className='text-4xl md:text-6xl font-bold'>JANATHA AUTO WORKS</h1>
            </div>
            <p className='text-xl md:text-2xl font-semibold bg-green-500 px-4 py-1 rounded-lg inline-block shadow-lg'>TEL TURBO AUTHORISED SERVICE CENTRE</p>
            <p className='text-lg md:text-xl text-gray-200 mt-4 max-w-4xl mx-auto'>
              Trusted. Trained. Turbocharged. Your official TEL TURBO Authorised Service Centre where performance meets precision.
            </p>
          </div>
        </div>
      </section>

      {/* About & Features Section */}
      <section className='py-16 px-4 md:px-8 lg:px-16'>
        <div className='max-w-7xl mx-auto'>
          <div className='text-center mb-12'>
            <img src={telturboLogo} alt="TEL Turbo Logo" className='w-24 h-24 md:w-32 md:h-32 mx-auto mb-4' />
            <h2 className='text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900'>Precision Turbo Solutions Since 2007</h2>
            <div className='w-20 h-1 bg-green-500 mx-auto mt-4'></div>
            <p className='text-lg md:text-xl text-gray-600 mt-6 max-w-4xl mx-auto'>
              Welcome to Janatha Auto Works, your official TEL TURBO Authorised Service Centre (ASC) — where performance meets precision. Whether you demand power, reliability, or speed, we deliver factory-certified expertise and world-class service to keep your machines operating at peak performance.
            </p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
            {/* Feature Cards */}
            <div className='bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1'>
              <img src={telturbo3} alt="tel-turbo" className='border-4 border-green-500 mb-2 ' />
              <h3 className='text-xl md:text-2xl font-bold text-center mb-3'>1. Factory-Trained Technicians</h3>
              <p className='text-gray-600 text-center'>
                Our technicians are trained by TEL professionals to handle everything from routine check-ups to complex diagnostics — with skill, care, and unmatched precision.
              </p>
            </div>
            <div className='bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1'>
              <img src={telturbo4} alt="tel-turbo" className='w-full h-36 border-4 border-green-500 mb-2 ' />
              <h3 className='text-xl md:text-2xl font-bold text-center mb-3 '>2. Always Stocked, Always Ready</h3>
              <p className='text-gray-600 text-center'>
                We ensure rapid turnaround times, high availability of spares, and minimal downtime for your fleet.
              </p>
            </div>
            <div className='bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1'>
              <img src={telturbo6} alt="tel-turbo" className='w-full h-36 border-4 border-green-500 mb-2 ' />
              <h3 className='text-xl md:text-2xl font-bold text-center mb-3 '>3. Comprehensive Turbo Solutions</h3>
              <p className='text-gray-600 text-center'>
                We offer preventive & scheduled maintenance, diagnostics, overhauls, road assistance, and sales of genuine TEL TURBO spares.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className='bg-white py-16 px-4 md:px-8 lg:px-16'>
        <div className='max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center'>
          <div className='order-2 lg:order-1'>
            <h2 className='text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4'>Why Choose Janatha Auto Works?</h2>
            <p className='text-lg md:text-xl text-gray-600 mb-6'>
              As an officially certified TEL TURBO ASC since 2007, we guarantee:
            </p>
            <ul className='space-y-4 text-lg font-medium'>
              {[
                '100% Genuine Spare Parts',
                'Warranty-Compliant Repairs & Servicing',
                'Direct Technical Support from TEL TURBO',
                'Factory-Trained Technicians',
                'Rapid Turnaround Times',
              ].map((item, index) => (
                <li key={index} className='flex items-center text-gray-700'>
                  <BsCheckCircleFill className='text-green-500 mr-3 text-xl flex-shrink-0' />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className='order-1 lg:order-2 h-full'>
            <img src={telturbo1} alt="Turbo service" className='w-full h-full object-center rounded-xl shadow-2xl border-4 border-green-500 transform hover:scale-105 transition-transform duration-500' />
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className='py-16 px-4 md:px-8 lg:px-16 bg-gray-50'>
        <div className='max-w-7xl mx-auto'>
          <h2 className='text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-12 text-gray-900'>Gallery</h2>
          <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6'>
            {[ telturbo2, telturbo3, telturbo4, telturbo5, telturbo6, telturbo7, telturbo8, telturbo4 ].map((image, index) => (
              <div key={index} className='overflow-hidden rounded-xl shadow-lg transform transition-transform duration-300 hover:scale-105'>
                <img src={image} alt={`Gallery image ${index + 1}`} className='w-full h-48 md:h-64 object-cover' />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact & Footer Section */}
      <section className='bg-gray-900 text-white py-16 px-4 md:px-8 lg:px-10'>
        <div className='max-w-7xl mx-auto'>
          <div className='text-center mb-12'>
            <h2 className='text-4xl md:text-5xl lg:text-6xl font-bold mb-3 text-green-400'>Let's Get You Turbocharged</h2>
            <p className='text-lg md:text-xl text-gray-300 max-w-2xl mx-auto'>
              Need expert service, genuine parts, or a maintenance partner you can trust? We're just a call away.
            </p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
            {/* Contact Information Card */}
            <div className='bg-gray-800 p-6 rounded-xl shadow-lg'>
              <h3 className='text-2xl font-bold mb-4 text-green-300'>Contact Information</h3>
              <div className='space-y-6'>
                {/* Hospet */}
                <div>
                  <p className='text-md font-semibold text-green-400 mb-1'>Hospet</p>
                  <a href="tel:8884013007" className='flex items-center gap-2 text-gray-300 hover:text-green-300 transition-colors'>
                    <FaPhoneAlt className='text-green-500' />
                    88840 13007
                  </a>
                  <a href="mailto:jaw.hpt@gmail.com" className='flex items-center gap-2 text-sm text-gray-300 hover:text-green-300 transition-colors mt-1'>
                    <FaEnvelope className='text-green-500' />
                    jaw.hpt@gmail.com
                  </a>
                </div>
                <hr className='border-gray-700' />
                {/* Chitradurga */}
                <div>
                  <p className='text-md font-semibold text-green-400 mb-1'>Chitradurga</p>
                  <a href="tel:9742153614" className='flex items-center gap-2 text-gray-300 hover:text-green-300 transition-colors'>
                    <FaPhoneAlt className='text-green-500' />
                    9742153614
                  </a>
                  <a href="mailto:jaw.durga@gmail.com" className='flex items-center gap-2 text-sm text-gray-300 hover:text-green-300 transition-colors mt-1'>
                    <FaEnvelope className='text-green-500' />
                    jaw.durga@gmail.com
                  </a>
                </div>
                <hr className='border-gray-700' />
                {/* Ballari */}
                <div>
                  <p className='text-md font-semibold text-green-400 mb-1'>Ballari</p>
                  <a href="tel:9008788087" className='flex items-center gap-2 text-gray-300 hover:text-green-300 transition-colors'>
                    <FaPhoneAlt className='text-green-500' />
                    9008788087
                  </a>
                  <a href="mailto:jaw.hpt@gmail.com" className='flex items-center gap-2 text-sm text-gray-300 hover:text-green-300 transition-colors mt-1'>
                    <FaEnvelope className='text-green-500' />
                    jaw.hpt@gmail.com
                  </a>
                </div>
              </div>
            </div>

            {/* Address & QR Codes */}
            {[
              { city: 'Hospet', address: 'Near RTO Office, Harihar Road', branchKey: 'Tel Turbo::Hospet' },
              { city: 'Chitradurga', address: 'Opp Bapuji High School, NH-13 Road', branchKey: 'Tel Turbo::Chitradurga' },
              { city: 'Ballari', address: 'Plot no 1057/B, Old Bypass, Cowl Bazar Road, Opp. Eidgah, Behind Golden Function Hall, Ballari - 583102.', branchKey: 'Tel Turbo::Ballari' }
            ].map((location, idx) => {
              const qrUrl = qrCodes[location.branchKey] || null;
              return (
                <div key={idx} className='bg-gray-800 p-6 rounded-xl shadow-lg text-center flex flex-col items-center justify-center'>
                  <h3 className='text-2xl font-bold mb-2 text-green-300'>{location.city} Address</h3>
                  <p className='text-sm text-gray-400 mb-4'>Scan for directions</p>

                  {qrUrl ? (
                    <img src={qrUrl} alt={`QR Code for ${location.city}`} className='w-36 h-36 rounded-lg bg-white p-1 mb-3' />
                  ) : (
                    <div className='w-36 h-36 flex items-center justify-center rounded bg-white border-2 text-gray-400 mb-3 border-gray-200'>
                      QR Code not available
                    </div>
                  )}

                  <p className='mt-4 text-sm text-gray-400 max-w-[200px] mx-auto'>
                    {location.address}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default JAW_TELTURBO;
